// extracted by mini-css-extract-plugin
export default {"container":"StreamCamera_container__WGZ7W","pagination":"StreamCamera_pagination__RpA9k"};